import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          operations: "Operations",
          formFields: {
            selectPlaceHolder: "Select...",
            allPlaceHolder: "All",
            required: "Required Field",
            CreateAnElement :"Create An Element"
          },
          // here we will place our translations...
          sidebar: {
            anasayfa : 'Homepage',
            // ----------------------------------- Şirketler Hukuku Talepleri ---------------------------------
            sirketlerHukukuTalepleri: 'Commercial law',
            maHisseAlimSatimIslemleri: 'M&A Share Transcations',
            vekaletnameOlaylari : 'Approval of Power of Attorney',
            ortaklikJv : 'Partnership-JV Transactions',
            esasSözlesmeGenelKurulKararlari : 'Articles of Incorporation-  General Assembly Decisions',
            yurtdisiIstiraklerinDigerHukukiIslemleri : 'Other Legal Operations of Foreign Subsidiaries',
            rekabetHukukuIzinBasvurusu : 'Competition Law Permission Application and Other Operations',
            rekabetHukukuIzin : 'Competition Law -Permission Application and Other Operations',
            rekabetHukukuSorusturmalar : 'Competition Law-Investigations',
            yurtDisiDavaveIhtilaflarinTakibi : 'Pursuit of Foreign Lawsuits and Disputes (Pladis and Godiva)',
            yurtDisiDavaveIhtilaflarinTakibiHarici : 'Pursuit of Foreign Lawsuits and Disputes (Pladis and FSM External)',
            dueDiligenceIslemleri : 'Due Diligence Operations',
            sirketlerHukukunaIliskinGorusTalepleri : 'Requests for Legal Advice on Corporate Law',
            yonetimKuruluKararlariveIlgiliEvraklar : 'Board Decisions and Related Documents',
            toplanti : 'Meeting',
            egitim : 'Education',
            sirketlerMutaala : 'Legal Opinion (Related Topics)',
            ishukukusurec: 'Labor Law Termination Processes',
            tsavciliksikayetleri: 'Prosecution Complaints',
            ttoplanti: 'Meeting',
            tegitim: 'Education',
            tsozlesmehazirlanmasi: 'Contract Preparation/Review',
            // ------------------------------------ Dava / İcra Talepleri ----------------------------------------
            davaIcraTalepleri : 'Litigation Execution Law',
            davaYeniTalep : 'Filing a Lawsuit',
            icraTalibiYeniTalep : 'Execution Proceeding - New Request',
            hacizIhbarnameleriveMaasHacizYazilarinaCevap : 'Preparation of a notice /Response to notice',
            basipHukukuTekzip : 'Press Law / Refutation',
            savcilikLeheAleyhe : 'Prosecution(in Favor / Against)',
            ihtarnameHazirlanmasi : 'Demand Letter',
            mahkemelerdenGelenYazilaraCevap : 'Response to the Writings Coming From Courts',
            davaIcraHukukuRaporlamalar : 'Litigation Law-Reportings',
            isHukukuFesihSurecleri : 'Termination Process in Labor Law',
            aleyhimiziAcilenDavaTakibi: 'Pursuit of the Case that Filed Against Us',
            // toplanti : 'Meeting',
            // egitim : 'Education',
            // --------------------------------------- Sözleşmeler Hukuku Talepleri -----------------------------------
            sözlesmeHukukuTalepleri : 'Contract Law',
            sözlesme : 'Contract',
            sözlesmelerleIlgiliSoruveUyusmazliklar : 'Questions and Disputes Regarding Contracts',
            // toplanti : 'Meeting',
            // egitim : 'Education',
            // --------------------------------------- Fikri Mülkiyet Hukuku Talepleri ---------------------------------
            fikriMülkiyetHukukuTalepleri : 'Intellectual Property Law',
            yeniDava : 'New Lawsuit',
            fmhAleyheDava:'Intellectual Propery Law Litigations Against Us',
            markaPatentEndüstriyelTasarim : 'Trademark, Patent, Industrial Design Processes',
            ihtarnameHazirlanmasiIhtarnameyeCevap : 'Demand Letter',
            fhmIliskinRaporlamalar : 'Reportings IPL',
            fmhRaporlamalar : 'Reportings IPL',
            sinaiMülkiyetHaklarinaIliskinSözlesme : 'Preparation of Contracts Regarding Industrial Property Rights',
            reklamSenaryosuIleIlgiliTalepler : 'Advertising Scenario Requests',
            reklamIleIlgiliDigerTalepler : 'Other Requests Related to Advertising',
            bilisimveInternetHukukuIleIlgiliTalepler : 'Internet and IT Law Requests',
            fikriMülkiyetHukukunaIliskinHukukiGorus : 'Legal Opinions on Intellectual Property Law and Other',
            sinaiHaklaraIliskinBeyanlar: 'Statements Regarding Industrial Property Rights',
            // toplanti : 'Meeting',
            // egitim : 'Education',
            // --------------------------------------- Genel Hukuk Talepleri---------------------------------------------
            genelHukukTalepleri: 'General Law',
            resmiKurumTalepItirazCevapYazilari: 'Official Institution Request, Objection, Reply Letters',
            hukukiGorusTalepleri: 'Legal Opinion Requests',
            spkMevzuatiTalepleri: 'SPK Regulations Requests',
            halkaArzIslemleriTahvilBonoIhraci: 'Public Offering Operations / Debt Securities Export',
            mevzuatIncelemeVeGorusTalebi: 'Review of Regulations and Request for Opinion',
            digerGenelHukukTalepleri: 'Other General Law Requests',
            halkaAcikSirketIslemleri: 'Public Company Operations(GK/GY etc.)',
            resmiMerciDenetimleri: 'Official Audits, Application and Legal Support Processes',
            sirketYonetmelikPolitikaProsedürInceleme: 'Legal Circular/Implementation Flow Text',
            kisiselVeriler: 'Processes Related to Personal Data',
            isHukukundanDoganTalep: 'Requests of Employment Law',
            genelHukukIhtarname: 'Drawing Up/Responding to Warning Letters',
            // toplanti : 'Meeting',
            // egitim : 'Education',
            // ---------------------------------------- Regülasyon Talepleri ---------------------------------------------
            regülasyonTalepleri: 'Regulation',
            bakanliktanResmiYanitTalepleri: 'Official Response Requests from the Ministry',
            kanunYonetmelikveTebliglerHakkindaBilgilendirme: 'Information on Laws, Regulations and Annunciation',
            uluslararasiRegülasyonlarveUygulamalarKonusunda: 'Information Requests on International Regulations and Practices',
            reklamveTanitimFaaliyetlerininIceriklerinin: 'Control and Evaluation of the Content of Advertising and Promotion Activities',
            cevreKanunuIleIlgiliTalepler: 'Requests Related to Environmental Law',
            regülasyonDiger: 'Other Regulations',
            yasalDenetimlerveRakipFirmaSikayetleri: 'Official Audit and Complaints of Rival Companies',
            // toplanti : 'Meeting',
            // egitim : 'Education',
            // ----------------------------------------- Başkanlık --------------------------------------------------------
            baskanlik: 'Presidency',
            globalHukukIsleriBaskanindanGorusveDestekTalepleri: 'Opinion From the Head of Global Legal Affairs and Support Requests',
            // toplanti : 'Meeting',
            // ----------------------------------------- Şirketler Hukuku --------------------------------------------------
            sirketlerHukuku: 'Corporate Law',
            svekaletname: 'Preparation / Review of Power of Attorney',
            sraporlamalar: 'Reports',
            smutalaa: 'Legal Opinion (Consulting)',
            sihtarname: 'Preparation of a notice, response to notice',
            // ----------------------------------------- Türkiye İştirakleri Hukuku ----------------------------------------
            turkiyeIstirakleri: 'Turkey Affiliates Law',
            tioMutalaa: 'Legal Opinion (Consulting)',
            tioIhtarname: 'Preparation of a notice / Response to notice',
            tioSozlesmeHazirlanmasi: 'Drafting and Examining Contracts',
            tioSozlesmeUyusmazliklar: 'Disputes&Questions Concerning Contracts',
            tioVekaletname: 'Preparation and Examining of Power of Attorney',
            tioYenidava: 'Filing a Lawsuit',
            tioAleyhedava: 'Litigations Against Us',
            tioSavcilik: 'Prosecutorial Complaint',
            tioIcratakip: 'Executive Proceeding',
            tioHacizihbar: 'Response to Notices of Attachment and Salary Attachment Warrant',
            tioMahkemecevap: 'Response to Warrants of Courts',
            tioBasintekzip: 'Press Law-Refutation-Correction',
            tioRaporlamalar: 'Reportings',
            tioSirketegitim: 'In-House Education',
            // ----------------------------------------- Raporlar  --------------------------------------------------------
            raporlar: 'Reports',
            grafikRaporlar: 'Graphic Reports',
            süreHesaplamalari: 'Time Calculation',
            digerRaporlamalar: 'Other Reportings',
            isYogunlugu: 'Workload',
            IsYogunlugu: "Workload",
            // ----------------------------------------- Rol ve Yetkilendirme ----------------------------------------------
            rolveYetkilendirme: 'Role and Authorization',
            departmanlar: 'Departments',
            kullanicilar: 'Users',
            sirketler: 'Companies',
            sirketGruplari: 'Company Groups',
            roller: 'Roles',
            // ------------------------------------------ Arşiv ve Yönetimi ------------------------------------------------
            arsivVeYonetimi: 'Archive and Its Managements',
            sozlesmeler: 'Contracts',
            vekaletnameler: 'Power of Attorney',
            davaIcraSavcilikSikayetleri: 'Case / Execution / Prosecution Complaints',
            ihtarnameler: 'Legal Notice',
            isAkdiFesihleri: 'Termination of Labor Contracts',
            // ------------------------------------------ Bilgi Bankası ----------------------------------------------------
            bilgiBankasi: 'Data Bank',
            tipSözlesmeler: 'Standard Contracts',
            dilekceOrnekleri: 'Petition Examples',
            hukukiBilgiNotlari: 'Notes of Information Regarding Law',
            fikriMülkiyetHukuku: 'Intellectual Property Law',
            emsalKararlar: 'Leading Case',
            // ------------------------------------------ GHİB Hakkında ----------------------------------------------------
            ghibHakkinda: 'About GHIB',
            ghibKullanimKilavuzu: 'GHIB User Manual',
            ghibYonetmeligi: 'GHIB Regulations',
            ghibDuyurular: 'GHIB Announcements',
            // ------------------------------------------- Ayarlar ---------------------------------------------------------
            ayarlar: 'Settings',
            talepTürleri: 'Request Types',
            dosyaTürleri: 'Folder Types',
            talepDurumlari: 'Request Status',
            dosyaDurumlari: 'File Status',
            mailMesajlari: 'Mail Messages',
            bilgiBankasiKategoriler: 'Categories of Data Bank',
            bilgiBankasiKategorileri: 'Categories of Data Banks',
            duyurular: 'Announcements',
            mevcutKayitlariDuzenle: 'Edit Existing Records',
            details: 'details',
            duyuruListesi : 'Announcement List',
            // PLADIS
            pladissozlesmehazirlanmasi: 'Contract and Preparation Management',
            pladissozlesmeuyusmazliklar: 'Disputes Questions Concerning Contracts',
            pladisyenidava: 'Filing a Lawsuit',
            pladisaleyheacilan: 'Intellectual Propery Law Litigations Against Us',
            pladisicra: 'Executive Proceeding',
            pladissavcilik: 'Prosecution Complaints',
            pladismutalaa: 'Opinion (Consultation)',
            pladishaciz: 'Response to Notices of Attachment and Salary Attachment Warrant',
            pladismahkemelerdengelenyazilar: 'Response to Warrants of Courts',
            pladisishukukufesih: 'Labor Law Termination Processes',
            pladisraporlamalar: 'Reports',
            pladisegitim: 'Education',
            pladisttoplanti: 'Meeting',
            pladisihtarname: 'Preparation of Notices, Responses',
            pladisvekaletname: 'Preparation/Review of Power of Attorney',
            // Marka
            mpmarkaPatentEndustriyelTasarim: 'Trademark, Patent, Industrial Design Operations',
            mpsinaiHaklarSozlesmeHazirlama: 'Preparation of Contracts/Statements Concerning Industrial Property Rights',
            mpyurtdisiYeniDavaAcilmasi: 'Filing a New Lawsuit Abroad',
            mpyurtdisiAleyheDavaTakibi: 'Following a Lawsuit Filed Against You Abroad',
            mpyurtdisiIhtarnameHazirlanmasi: 'Preparation and Response to a Notice Abroad',
            mpegitim: 'Education',
            mptoplanti: 'Meeting',
            mpraporlamalar: 'Reports',
            mpmutalaaDanisma: 'Opinion (Consultation)',
            thkamulastirma: 'Cases Regarding Expropriation and Zoning Legislation',
            thyurtdisidava: 'Coordination of Foreign Cases and Disputes'
          },
          demandCreate: {
            turkiyeSirketleri: 'Turkey Companies',
            yurtDisiSirketleri: 'Overseas Companies',
            dosyaNo: 'File Number',
            grup: 'Group',
            mensei: 'Origin',
            grupSirketi: 'Group Company',
            sorumluAdi: 'Responsible Name',
            sorumluEPosta: 'Responsible E-Mail ',
            sorumluTel: 'Responsible Phone No',
            sorumluRol: 'Responsible Role',
            dosyaTürü: 'File Type',
            dosya: 'File',
            konu: 'Subject',
            aciklama: 'Explanation',
            dil: 'Language',
            paraBirimi: 'Currency',
            tahminiBedel: 'Estimated Cost',
            bedel: 'Cost',
            davali: 'Defendant',
            müdahil: 'Intervener ',
            daireNo: 'Court No',
            taraf1: 'Party 1',
            yeniTalepButton: 'New Request',
            ekle: 'Add',
            yurtici: 'Domestic',
            yurtdisi: 'Foreign',
            davaTuru: 'Type Of Case',
            vekil: "Attorney",
            basvuruYapilacakSirket: "Company To Apply",
            davaci: "Plaintiff",
            ihtarEdilen: "Warned",
            vekilinCalistigiSirket: "Company of Attorney",
            musteki: "Complainant",
            ihtarEden: "Noticer",
            supheli: "Suspect",
            durusmaTarihi: "Hearing Date",
            davaTutari: "Case Amount",
            takipTutari: "Amount of Enforcement Proceeding",
            sozlesmeBedeli: "Contract Price",
            resmiDaire: "Government Offices",
            ilgiliSirket: "Related Company",
            alacakli: "Payee",
            borclu: "Debtor",
            turkiyeSirketleriUyari: "A request can be open under this department if the requesting company is Yıldız Holding Turkey Affiliates. A request shall be open under the Commercial Law Department if the requesting Company is not Yıldız Holding Turkey Affiliates.",
            ticaretHukukuUyari: "A request can be open under this department unless the requesting company is Yıldız Holding Turkey Affiliates. A request shall be open under the Turkish Affiliates Office Department for Yıldız Holding Turkey Affiliates.",
            successCreate: "Your {{id}} request has been created successfully.",
            turkiyeSirketleriVeTicaretHukUyari: "For \“Yıldız Holding Turkey Affiliates\” companies, GLAS requests shall be opened under \“Yıldız Holding Turkey Affiliates\” section and for other group companies including Yıldız Holding, pladis, Godiva, Yıldız Ventures companies GLAS requests can be opened under Commercial Law section.",
            other: 'Other',
            markImportant: 'Mark as important',
            muddeabih:"Object Of Demnd",
            ilgiliSirket: "Related Company (Company information on whose behalf a request is entered)",
            sirketUyari: "Şirketler hukuku sekmesinden açılan taleplerde , yurtdışı-yurtiçi şirketi seçeneklerinin her ikisi de işaretlendikten sonra işlem yapılmalıdır."
          },
          grupCompanies: {
            grup: 'Group',
            menşei: 'Origin',
            kurumTipi: 'Institution Type',
            sirket: 'Company',
            ghibSorumlusu: 'Individual Responsible of GHIB',
            notlar: 'Notes',
            ilgiliAvukat: 'İlgili Şirket Avukatı'
          },
          groups: {
            grup: 'Group',
            grupEn: 'Group (English)',
            sirketler: 'Companies',
          },
          roles: {
            adi: 'Name',
            aciklama: 'Explanation',
          },
          sozlesmeler: {
            dosyaNo: 'File Number',
            islemNo: 'Process Number',
            dosyaTuru: 'File Type',
            durum: 'Status',
            grup: 'Group',
            grupSirketi: 'Group Company',
            konu: 'Subject',
            taraf: 'Party',
            dil: 'Language',
            avukat: 'Lawyer',
            tahminiBilgi: 'Estimated Cost',
            paraBirimi: 'Currency',
            baslangicBedel: 'Starting Cost',
            bitisBedel: 'Ending Cost',
            baslangicTarihi: 'Addition Date (Start)',
            bitisTarihi: 'Addition Date (End)',
            filtreleme: 'Filtration',
            filtrele: 'Filter',
          },
          vekaletnameler: {
            islemNo: 'Process Number',
            vekaletnameNo: 'Power of Attorney Number',
            durum: 'Status',
            grup: 'Group',
            grupSirketi: 'Group Company',
            konu: 'Subject',
            avukat: 'Lawyer',
            baslangicTarihi: 'Starting Date',
            bitisTarihi: 'Ending Date',
            filtreleme: 'Filtration',
          },
          davaIcraSavcilik: {
            golgeDNo: 'Shadow D. Number',
            islemNo: 'Process Number',
            mahkemeNo: 'Court Number',
            icraNo: 'Executive Number',
            dosyaTuru: 'File Type',
            dosyaGrubu: 'File Group',
            grup: 'Group',
            grupSirketi: 'Group Company',
            konu: 'Subject',
            aciklama: 'Explanation',
            davaci: 'Complainant',
            davaciDiger: 'Other Complainant',
            davaciList : 'Complainant List',
            davali: 'Defendant',
            davaliDiger: 'Other Defendant',
            davaliList : 'Defendant List',
            avukat: 'Lawyer',
            eklemeBaslangicTarihi: 'Adding (Starting Date)',
            eklemeBitisTarihi: 'Adding (Ending Date)',
            kapanisBaslangicTarihi: 'Closing (Starting Date)',
            kapanisBitisTarihi: 'Closing (Ending Date)',
            durusmaTakipBasTarihi: 'Hearing/Follow-up (Starting Date)',
            durusmaTakipBitTarihi: 'Hearing/Follow-up (Ending Date)',
            DavaliSirket: 'Defendant Company',
            davaciSirket: 'Complainant Company',
            kullaniciadi: 'User Name'
          },
          ihtarnameler: {
            islemNo: 'Process Number',
            ihtarnameNo: 'Dunning Letter Number',
            taraf: 'Party',
            durum: 'Status',
            grup: 'Group',
            grupSirketi: 'Group Company',
            dosyaTuru: 'File Type',
            konu: 'Subject',
            avukat: 'Lawyer',
            baslangicTarihi: 'Starting Date',
            bitisTarihi: 'Ending Date',
            filtreleme: 'Filtration',
          },
          isAkdiFesihleri: {
            islemNo: 'Process Number',
            isAkdiFesihNo: 'Termination of Labor Contract No',
            taraf: 'Party',
            durum: 'Status',
            grup: 'Group',
            grupSirketi: 'Group Company',
            dosyaTuru: 'File Type',
            konu: 'Subject',
            avukat: 'Lawyer',
            baslangicTarihi: 'Starting Date',
            bitisTarihi: 'Ending Date',
            filtreleme: 'Filtration',
          },
          demandTypes: {
            departman: 'Department',
            talepTürü: 'Request Type',
            talepTürüTr: 'Request Type(Turkish)',
            talepTürüEn: 'Request Type(English)',
            numaraOneki: 'Row Number',
          },
          documentTypes: {
            departman: 'Department',
            üstTür: 'Top Type',
            talepTürleri: 'Request Types',
            türKodu: 'Type Code',
            dosyaTürü: 'File Type',
            dosyaTürüTr: 'File Type(Turkish)',
            dosyaTürüEn: 'File Type(English)',
            ücret: 'Fee',
            talepTuru: 'Talep Türü'
          },
          demandStates: {
            talepDurumu: 'Request Status',
            talepDurumuTr: 'Request Status(Turkish)',
            talepDurumuEn: 'Request Status(English)',
          },
          newAnnouncements: {
            baslik : 'Announcement Title',
            icerik : 'Content',
            bitisTarihi : 'End Date',
            aktif: 'Active Status',
            duyuru: 'Add Announcement'
          },
          documentStates: {
            departman: 'Department',
            talepTürleri: 'Request Types',
            durumKodu: 'Status Code',
            dosyaDurumu: 'File Status',
            dosyaDurumuTr: 'File Status(Turkish)',
            dosyaDurumuEn: 'File Status(English)',
          },
          demandDocType: {
            evrakTipi: 'Document Type Name',
            evrakTipiEn: 'Document Type Name(English)',
            evrakTipiTr: 'Document Type Name(Turkish)',
          },
          mailMessages: {
            mailKodu: 'Mail Code',
            aciklama: 'Explanation',
            konu: 'Subject',
            mesaj: 'Message',
          },
          infoBanksCategories: {
            ustKategori: 'Top Category',
            kategoriAdi: 'Category Name',
          },
          announcements: {
            duyuruBasligi: 'Announcement Title',
            duyuruMetni: 'Announcement Text',
          },
          fileUpload: {
            dosyaUpload: 'You can drag and drop or click to upload files.',
            uploadSuccess: 'File uploaded successfully.',
          },
          tamamlaButton: {
            tamamla: 'Complete',
            gonder: 'Send',
          },
          demandList: {
            islemNo: 'GLAS Process Number',
            grup: 'Group',
            grupSirketi: 'Group Company',
            ilgiliSirket: 'Related Company',
            talepTuru: 'Request Type',
            talepTuruEn: 'Request Type(English)',
            talepTuruTr: 'Request Type(Turkish)',
            talepDurumu: 'Request Status',
            talepDurumuEn: 'Request Status(English)',
            talepDurumuTr: 'Request Status(Turkish)',
            konu: 'Subject',
            isGücüBirim: 'Unit of Labor Force',
            departmanAdi: 'Department Name',
            kullaniciAdi: 'User Name',
            adiSoyadi: 'Name Surname',
            userName: 'User Name',
            avukatKodu: 'Lawyer Code',
            ePosta: 'E-Mail',
            durum: 'Status',
            durumAktif: 'Active',
            durumPasif: 'Passive',
            aktifDurum: 'Is it Active? ',
            kurumTip: 'Institution Type',
            kurumAdi: 'Institution Name',
            grupAdi: 'Group Name',
            grupAdiEn: 'Group Name (English)',
            adi: 'Name',
            aciklama: 'Explanation',
            grupSirket: 'Group Company',
            turKodu: 'Type Code',
            dosyaTuru: 'File Type',
            dosyaTuruTr: 'File Type(Turkish)',
            dosyaTuruEn: 'File Type(English)',
            durumKodu: 'Status Code',
            dosyaDurumu: 'File Status',
            dosyaDurumuTr: 'File Status(Turkish)',
            dosyaDurumuEn: 'File Status(English)',
            mailKodu: 'Mail Code',
            ustKategoriAdi: 'Top Category Name',
            kategoriAdi: 'Category Name',
            duyuruBas: 'Announcement Title',
            gonderenKisi: 'Received From',
            tarih: 'Date',
            sozlesmeNo: 'Contract Numner',
            dil: 'Language',
            bedel: 'Cost',
            karsiTaraf: 'Opposite Party',
            sözlesmeTuru: 'Contract Type',
            baslangicTarihi: 'Starting Date',
            bitisTarihi: 'Ending Date',
            dövizCinsi: 'Currency',
            ekleyen: 'Inserted by',
            eklemeTarihi: 'Adding Date',
            avukat: 'Lawyer',
            golgeDNo: 'Shadow D. Number',
            departman: 'Department',
            gorevliAvukat: 'Attendant Lawyer',
            talepTarihi: 'Request Date',
            tamamlamaTarhihi: 'Completing Date',
            tamamlamaTarihi: 'Completing Date',
            talepBilgisi: 'Request Information',
            sonDurum: 'Last Status',
            vekaletNo: 'Power of Attorney Number',
            isAkdiFesihNo: 'Termination of Labor Contract No',
            isAkdiFesihTuru: 'Termination of Labor Contract Type',
            ihtarnameNo: 'Legal Notice Number',
            ihtarnameTuru: 'Legal Notice Type',
            davaci: 'Complainant',
            davali: 'Defendant',
            davaTuru: 'Lawsuit Type',
            sirketIciYetkili: 'In-house Authority',
            yetkiliKisi: 'Authorized Person',
            kullaniciRolu: 'User Role',
            disKod: 'Out Code',
            taraf1: "Plaintiff",
            sirketDurumu: "Company Status",
            yurtici: "Turkey/Abroad Companies",
            istirakSirketleri: "Affiliate Companies",
            KullaniciAdi: "User Name",
            bekleyenSayisi: "number of waiting",
            atananSayisi: "Directed number",
            devamEdenSayisi: "Continue Number",
            tamamlananlarSayisi: "Completed Number",
            importantInfo: "Is it marked important?",
            enAz:"At Least",
            enCok: "Most",
            muddeabih:"Object Of Demnd",
            davaTuru1: "Lawsuit Type 1",            
            davaTuru2: "Lawsuit Type 2"
          },
          pageTitleofDemandCreate: {
            sirketlerHukukuToplanti: 'Corporate Law Meeting',
            sirketlerHukukuEgitim: 'Corporate Law Seminar',
            davaIcraToplanti: 'Lawsuit-Execution Meeting',
            davaIcraEgitim: 'Lawsuit-Execution Seminar',
            sözlesmelerHukukuToplanti: 'Contracts Law Meeting',
            sözlesmelerHukukuEgitim: 'Contracts Law Education',
            fmhToplanti: 'Intellectual Property Law Meeting',
            fmhEgitim: 'Intellectual Property Education',
            genelHukukToplanti: 'General Law Meeting',
            genelHukukEgitim: 'General Law Education',
            regulasyonToplanti: 'Regulation Meeting',
            regulasyonEgitim: 'Regulation Education',
            baskanlikToplanti: 'Presidency Meeting',
            talepDurum: 'Request Status',
            dosyaDurum: 'File Status',
            mailMesajı: 'Mail Message',
            bilgiBankasiKategori: 'Data Bank Category',
            bilgiBankasiFiles: 'Bilgi Bankası Dosyalar',
            duyuru: 'Announcement',
            evrakTipi: 'Document Type',
            isyogunlugu:'workload'
          },
          anaSayfa: {
            glasaHosGeldiniz: "Welcome to GLAS!",
            avukatlikYoneticisi: 'Advocacy Manager Control Panel',
            bekleyenTalepler: 'PENDING REQUESTS',
            yonlendirilmisTalepler: 'DIRECTED REQUESTS',
            tumTalepler: 'ALL REQUESTS',
            surecDevamEdenTalepler: 'ONGOING REQUESTS',
            sureciDevamEdenTalepler: 'THE PROCESS CONTINUES',
            tamamlananlar: 'COMPLETED',
            dosyalar: 'FILES',
            reddedilenler: 'REJECTED',
            yeniTalepler: 'NEW REQUESTS',
            atananlar: 'ASSIGNED',
            duyurular: 'ANNOUNCEMENTS',
            evrakTipi: "Document Type"
          },
          table: {
            veriYok: 'No data!',
            kayitaraligi: 'Records-Between-in-Records',

            glasIslemNo:'Glas operation No',
            grupSirketi: 'Group Company',
            talep:'Apply',
            konu:'Subject',
            isGucuBirim:'unit Of Power',
            baslamaTarihi: 'Start Date',
            bekleyenler: 'Waiting',
            yonlendirilmis:'Directed',
            devamEden: 'continuesly',
            tammam:'Finished',
            sorumluAdi: 'Responsible Name',
          },
          actionButtons: {
            islemler: 'PROCESSES:',
          },
          demandUpdate: {
            islemNo: 'GLAS Process Number',
            talepEdenSirket: 'The Requesting Company',
            talepEdenKisi: 'The Requesting Person',
            talepTarihi: 'Request Date',
            dosya: 'File',
            sorumluAdi: 'Responsible Name',
            sorumluePosta: 'Responsible E-Mail',
            sorumluTelefon: 'Responsible Phone No',
            dosyaTuru: 'File Type',
            konu: 'Subject',
            explanation: 'Explanation',
            avukatYorumu: 'Lawyer Comment',
            yonlendiriciYorumu: 'Router Comment',
            delegeEdilen: 'Delegated',
            iadeNedeni: 'Cause of Return',
            iadeEdenKullanici: 'Returning User',
            iadeTarihi: 'Return Date',
            redNedeni: 'Cause of Reject',
            redEdenKullanici: 'Rejecting User',
            redTarihi: 'Reject Date',
            dil: 'Language',
            isGucuBirim: 'Unit of Labor Force',
            isGucuBirimDiger: 'İş Gücü Birim Diğer',
            davaTuru: 'Lawsuit Type',
            tarih: 'Date',
            dosyaDurum: 'File Status',
            gorevlendirilenDisAvukat: 'Appointed Foreign Lawyer',
            gorevlendirilenDisAvukatDiger: 'Appointed Foreign Lawyer (Other)',
            davali: 'Defendant',
            müdahil: 'Intervenor',
            daireNo: 'Court Number',
            icraNo: 'Executive Number',
            taraf: 'Party 1',
            disAvukatGorebilir: 'Out-Source Lawyer can see',
            talepFiltrele: 'Request Filter',
            bilgideTut: "Keep Informed",
            savcilikNo: "Prosecution No",
            importantInfo: "Is it marked important?",
            davaTuru1: "Lawsuit Type 1",            
            davaTuru2: "Lawsuit Type 2"
          },
          documentUpdate: {
            islemNo: 'GLAS Process Number',
            dosyaNo: 'File Number',
            dosya: 'File',
            sorumluAdi: 'Responsible Name',
            sorumluEPosta: 'Responsible E-Mail',
            sorumluTelefon: 'Responsible Phone No',
            dosyaTuru: 'File Type',
            konu: 'Subject',
            aciklama: 'Explanation',
            dosyaDurum: 'File Status',
            tahminiBedel: 'Estimated Cost',
            bedel: 'Cost',
            paraBirimi: 'Currency',
            dil: 'Language',
            baslangicTarihi: 'Starting Date',
            bitisTarihi: 'Ending Date',
            avukatYorumu: 'Lawyer Comment',
            yonlendiriciYorumu: 'Router Comment',
            yorumlar: 'Comments',
            sicilKaydiVar: 'Has a registry',
            sirkulerVar: 'Has a Circular Letter',
            cezaVar: 'There is a punishment',
          },
          actionButtonGenerator: {
            guncelle: 'Update',
            aktifEt: 'Make it active',
            pasifEt: 'Make it inactive',
            sayfayaGit: 'Go to the page',
            sil: 'Delete',
            dosyaYukle: 'Load File',
            kullaniciDosyaYukle: 'Load User File',
            dosyaIndir: 'Download File',
            dosyalariIndir: 'Download',
            goruntule: 'View',
            yetkiEkle: 'Add Authority',
            atamaYap: "Make An Assigment",
            red: "Reject",
            baslat: "Start",
            iadeEt: "Return It",
            dosyayaDonustur: "Save",
            numaraVer: "Save And Give Number",
            taslak: "Save Draft",
            tamamla: "Complete",
            numaraVermeden: "Finish Without Number",
            bitir: "Finish",
            kaydet: "Save",
            ogeSecildi: "Item Selected",
            excel: "Download As Excel",
            formuTemizle: "Clear Form",
            tumKayitlariGuncelle: "Update All Item",
            arsivVeYonetim: 'Archive and Its Managements',
            infazNumaraVer: 'Give The Execution Number',
            deneme: 'Deneme',
          },
          header: {
            profile: "Go to profile",
            logout: "Logout",
            bulunamadi: "Nof Found",
          },
          report: {
            gorevlendirilen: "Assigned",
            talepatbas: "Request Opening Date(Start)",
            talepatbts: "Request Opening Date(End)",
            talepktbas: "Request Closing Date(Start)",
            talepktbts: "Request Closing Date(End)",
            talepDurumuId: "Request Status ID",
            kapanmaTarihi: "Closing Date",
            toplamSure: "Total Time",
            isGucuBirim: "Workforce Unit",
            sonDurum: "Latest Status",
            sonDurumEkleyen: "Adding The Latest",
            durusmaTarihiMin: "Trial Date (Min)",
            durusmaTarihiMax: "Trial Date (Max)",
            listeAlanlari: "List Fields",
            golgeNumarasi: "Is there a Glass Shadow Number?"
          },
          tabs: {
            bilgiler: "Infos",
            sonDurum: "Latest Status",
            dokumanlar: "Documents",
            harcananSureler: "Time Spent",
            talepAkisi: "Request Flow",

            ekleyen: "Adding",
            durum: "Status",
            tarih: "Date",
            eklendi: "Added",
            guncellendi: "Updated",
            successDelete: "Successfully Deleted",

            evrakTipi: "Document Type",
            evrakTipiAciklamasi: "Document Type Explanation",
            digerEvrakTipi: "Other Document Type",
            dosyaAdi: "File Name",

            sureDakika: "Duration(Minutes)",
            aciklama: "Description",
            ilgiliKisi: "Related Person",
            sure: "Duration",

            islemTipi: "Process Type",
            tarihSaat: "Date - Time",

            ekle: "Add",

            Bekleyenler: 'Waiting',
            YonlendirilmisTalepler: 'Directed',
            DevamEdenTalepler:'continuesly',
            TammamlanimisTalepler:'finished',
            guncelle: 'Update',
          
            kullanicilar: 'Users',
            KullaniciDosyalari:'Files',
            Roller: 'Roller',
            departmanlar:'Departmanlar',
            kullaniciBilgileri: 'Kullanıcı Bilgileri',

            masraflar: 'Masraflar'
          },
          userRole: {
            kullanici: "User",
            kullaniciDosya: "User Files",
            sirketGrubu: "Company Group",
            rolAdi: "Role Name",
            rol: "Role",
            back: "Go Back",
            kullaniciRol: "User-Role",
            roller: "Roles",
            menuler: "Menus"
          },
          userDepartment: {
            talepTurleriId: "Request Type ID",
            talepTurleriAdı: "Request Type Name",
            talepTurleri: "Request Types",
            kullaniciDepartman: "User-Department",
            departmanlar: "Departments"
          },
          userArchiveCheckBox: {
            ARSIV_SOZLESME_VEKALET: "Contract / Power of Attorney",
            ARSIV_DAVA_ICRA: "Litigation Execution"
          },
          modal: {
            yesButton: "Yes",
            noButton: "No",
            areYouSure: "Are you sure want continue?",
            warningTitle: "Warning!",
          },
        }
      },
      tr: {
        translation: {
          operations: "İşlemler",
          formFields: {
            selectPlaceHolder: "Seçiniz...",
            allPlaceHolder: "Tümü",
            required: "Zorunlu Alan"
          },
          // here we will place our translations...
          sidebar: {
            anasayfa: 'Anasayfa',
            // ----------------------------------- Şirketler Hukuku Talepleri ---------------------------------
            sirketlerHukukuTalepleri: 'Ticaret Hukuku',
            maHisseAlimSatimIslemleri: 'M&A-Hisse Devralınması İşlemleri',
            IsYogunlugu: "İş Yoğunluğu",
            vekaletnameOlaylari: 'Vekaletname Hazırlanması/İncelenmesi',
            ortaklikJv: 'Ortaklık - Joint Venture İşlemleri',
            esasSözlesmeGenelKurulKararlari: 'Şirket Ana Mukaveleleri / Tadilleri / Genel Kurul / YK kararları',
            yurtdisiIstiraklerinDigerHukukiIslemleri: 'Yurtdışı Dava ve İhtilafların Koordinasyonu',
            rekabetHukukuIzinBasvurusu: 'Rekabet Hukuku İzin Başvurusu ve Diğer İşlemler',
            rekabetHukukuIzin: 'Rekabet Hukuku-İzin Başvurusu ve Diğer İşlemler',
            rekabetHukukuSorusturmalar: 'Rekabet Hukuku-Soruşturmalar',
            yurtDisiDavaveIhtilaflarinTakibi: 'Yurtdışı Dava ve İhtilafların Takibi (Pladis ve Godiva Şirketleri)',
            yurtDisiDavaveIhtilaflarinTakibiHarici: 'Yurtdışı Dava ve İhtilafların Takibi (Pladis Şirketleri ve FSM Harici)',
            dueDiligenceIslemleri: 'Due Diligence Koordinasyonu',
            sirketlerHukukunaIliskinGorusTalepleri: 'Şirketler Hukukuna İlişkin Görüş Talepleri',
            yonetimKuruluKararlariveIlgiliEvraklar: 'İlmuhaber ve Hisse Senedine İlişkin Talepler',
            toplanti: 'Toplantı',
            egitim: 'Eğitim',
            sirketlerMutaala: 'Mütalaa (Danışma)',
            ishukukusurec: 'İş Hukuku Fesih Süreçleri',
            tsavciliksikayetleri: 'Savcılık Şikayetleri',
            ttoplanti: 'Toplantı',
            tegitim: 'Eğitim',
            tsozlesmehazirlanmasi: 'Sözleşme Hazırlanması/İncelenmesi',
            // ------------------------------------ Dava / İcra Talepleri ----------------------------------------
            davaIcraTalepleri: 'Savcılık/Ceza Hukuku İşlemlerinin Takip Edilmesi',
            davaYeniTalep: 'Yeni Dava Açılması',
            icraTalibiYeniTalep: 'İcra Takibi',
            hacizIhbarnameleriveMaasHacizYazilarinaCevap: 'Haciz İhbarnameleri ve Maaş Haciz Yazılarına Cevap Verilmesi',
            basipHukukuTekzip: 'Basın Hukuku / Tekzip / Sosyal Medya',
            savcilikLeheAleyhe: 'Savcılık Şikayetleri',
            ihtarnameHazirlanmasi: 'İhtarname Hazırlanması, Cevap Verilmesi',
            mahkemelerdenGelenYazilaraCevap: 'Mahkemelerden Gelen Yazıların Cevaplandırılması',
            davaIcraHukukuRaporlamalar: 'Raporlamalar',
            isHukukuFesihSurecleri: 'İş Hukuku Fesih Süreçleri',
            aleyhimiziAcilenDavaTakibi: 'Aleyhe Açılan Davanın Takibi',
            // toplanti : 'Toplantı',
            // egitim : 'Eğitim',
            // --------------------------------------- Sözleşmeler Hukuku Talepleri -----------------------------------
            sözlesmeHukukuTalepleri: 'Sözleşmeler Hukuku',
            sözlesme: 'Sözleşme Hazırlanması,İncelenmesi',
            sözlesmelerleIlgiliSoruveUyusmazliklar: 'Sözleşmelerle İlgili Soru ve Uyuşmazlıklar',
            // toplanti : 'Toplantı',
            // egitim : 'Eğitim',
            // --------------------------------------- Fikri Mülkiyet Hukuku Talepleri ---------------------------------
            fikriMülkiyetHukukuTalepleri: 'Fikri Mülkiyet Hukuku',
            yeniDava: 'Yeni Dava Açılması',
            fmhAleyheDava: 'Aleyhe Açılmış Davanın Takibi',
            markaPatentEndüstriyelTasarim: 'Marka, Patent, Endüstriyel Tasarım İşlemleri',
            ihtarnameHazirlanmasiIhtarnameyeCevap: 'Yurt İçi İhtarname Hazırlanması, Cevap Verilmesi',
            fhmIliskinRaporlamalar: 'Raporlamalar',
            fmhRaporlamalar: 'Raporlamalar',
            sinaiMülkiyetHaklarinaIliskinSözlesme: 'Sınai Mülkiyet Haklarına İlişkin Sözleşme Hazırlanması',
            reklamSenaryosuIleIlgiliTalepler: 'Reklam Senaryosu ile İlgili Talepler',
            reklamIleIlgiliDigerTalepler: 'Reklam ile İlgili Diğer Talepler',
            bilisimveInternetHukukuIleIlgiliTalepler: 'Bilişim ve İnternet Hukuku ile İlgili Talepler',
            fikriMülkiyetHukukunaIliskinHukukiGorus: 'Mütalaa (Danışma)',
            sinaiHaklaraIliskinBeyanlar: 'Sınai Haklara İlişkin Beyanlar',
            // toplanti : 'Toplantı',
            // egitim : 'Eğitim',
            // --------------------------------------- Genel Hukuk Talepleri---------------------------------------------
            genelHukukTalepleri: 'Genel Hukuk',
            resmiKurumTalepItirazCevapYazilari: 'Resmi Kurumlar Yazışma',
            hukukiGorusTalepleri: 'Mütalaa (Danışma)',
            spkMevzuatiTalepleri: 'SPK Mevzuatı ile İlgili Talepler',
            halkaArzIslemleriTahvilBonoIhraci: 'Halka Arz Süreç Koordinasyonu',
            mevzuatIncelemeVeGorusTalebi: 'Hukuki Araştırma/Mevzuat Araştırması',
            digerGenelHukukTalepleri: 'Genel Hukuk – Diğer',
            halkaAcikSirketIslemleri: 'Raporlamalar',
            resmiMerciDenetimleri: 'Finans Hukukuna İlişkin Talepler',
            sirketYonetmelikPolitikaProsedürInceleme: 'Hukuki Sirküler/Uygulama Akış Metni',
            kisiselVeriler: 'KVKK Uyum Konuları',
            isHukukundanDoganTalep: 'Belge Onayı/GLAS Numarası',
            genelHukukIhtarname: 'İhtarname Hazırlanması, Cevap Verilmesi',
            // toplanti : 'Toplantı',
            // egitim : 'Eğitim',
            // ---------------------------------------- Regülasyon Talepleri ---------------------------------------------
            regülasyonTalepleri: 'Regülasyon',
            bakanliktanResmiYanitTalepleri: 'Bakanlıktan Resmi Yanıt Talepleri',
            kanunYonetmelikveTebliglerHakkindaBilgilendirme: 'Kanun, Yönetmelik ve Tebliğler Hakkında Bilgilendirme',
            uluslararasiRegülasyonlarveUygulamalarKonusunda: 'Uluslararası Regülasyonlar ve Uygulamalar Konusunda Bilgi Talepleri',
            reklamveTanitimFaaliyetlerininIceriklerinin: 'Reklam ve Tanıtım Faaliyetlerinin İçeriklerinin Kontrolü ve Değerlendirmesi',
            cevreKanunuIleIlgiliTalepler: 'Çevre Kanunu ile İlgili Talepler',
            regülasyonDiger: 'Regülasyon Diğer',
            yasalDenetimlerveRakipFirmaSikayetleri: 'Yasal Denetimler ve Rakip Firma Şikayetleri',
            // toplanti : 'Toplantı',
            // egitim : 'Eğitim',
            // ----------------------------------------- Başkanlık --------------------------------------------------------
            baskanlik: 'Başkanlık',
            globalHukukIsleriBaskanindanGorusveDestekTalepleri: 'Başkanlık Talepleri',
            // toplanti : 'Toplantı',
            // ----------------------------------------- Şirketler Hukuku --------------------------------------------------
            sirketlerHukuku: 'Şirketler Hukuku',
            svekaletname: 'Vekaletname Hazırlanması/ İncelenmesi',
            sraporlamalar: 'Raporlamalar',
            smutalaa: 'Mütalaa (Danışma)',
            sihtarname: 'İhtarname Hazırlanması, Cevap Verilmesi',
            // ----------------------------------------- Türkiye İştirakleri Hukuku ----------------------------------------
            turkiyeIstirakleri: 'Türkiye İştirakleri Hukuk',
            tioMutalaa: 'Mütalaa (Danışma)',
            tioIhtarname: 'İhtarname Hazırlanması, Cevap Verilmesi',
            tioSozlesmeHazirlanmasi: 'Sözleşme Hazırlanması, İncelenmesi',
            tioSozlesmeUyusmazliklar: 'Sözleşmelerle İlgili Soru ve Uyuşmazlıklar',
            tioVekaletname: 'Vekaletname Hazırlanması, İncelenmesi',
            tioYenidava: 'Yeni Dava Açılması',
            tioAleyhedava: 'Aleyhe Açılan Davanın Takibi',
            tioSavcilik: 'Savcılık Şikayetleri',
            tioIcratakip: 'İcra Takibi',
            tioHacizihbar: 'Haciz İhbarnameleri ve Maaş Haciz Yazılarına Cevap Verilmesi',
            tioMahkemecevap: 'Mahkemelerden Gelen Yazıların Cevaplandırılması',
            tioBasintekzip: 'Basın Hukuku-Tekzip-Düzeltme',
            tioRaporlamalar: 'Raporlamalar',
            tioSirketegitim: 'Eğitim',
            // ----------------------------------------- Raporlar  --------------------------------------------------------
            raporlar: 'Raporlar',
            grafikRaporlar: 'Grafik Raporlar',
            süreHesaplamalari: 'Süre Hesaplamaları',
            digerRaporlamalar: 'Diğer Raporlamalar',
            isYogunlugu: 'İş Yoğunluğu',
            // ----------------------------------------- Rol ve Yetkilendirme ----------------------------------------------
            rolveYetkilendirme: 'Rol ve Yetkilendirme',
            departmanlar: 'Departmanlar',
            kullanicilar: 'Kullanıcılar',
            sirketler: 'Şirketler',
            sirketGruplari: 'Şirket Grupları',
            roller: 'Roller',
            // ------------------------------------------ Arşiv ve Yönetimi ------------------------------------------------
            arsivVeYonetimi: 'Arşiv ve Yönetimi',
            sozlesmeler: 'Sözleşmeler',
            vekaletnameler: 'Vekaletnameler',
            davaIcraSavcilikSikayetleri: 'Dava / İcra / Savcılık Şikayetleri',
            ihtarnameler: 'İhtarnameler',
            isAkdiFesihleri: 'İş Akdi Fesihleri',
            // ------------------------------------------ Bilgi Bankası ----------------------------------------------------
            bilgiBankasi: 'Bilgi Bankası',
            tipSözlesmeler: 'Tip Sözleşmeler',
            dilekceOrnekleri: 'Dilekçe Örnekleri',
            hukukiBilgiNotlari: 'Hukuki Bilgi Notları',
            fikriMülkiyetHukuku: 'Fikri Mülkiyet Hukuku',
            emsalKararlar: 'Emsal Kararlar',
            // ------------------------------------------ GHİB Hakkında ----------------------------------------------------
            ghibKullanimKilavuzu: 'GHİB Kullanım Kılavuzu',
            ghibYonetmeligi: 'GHİB Yönetmeliği',
            ghibDuyurular: 'GHIB Duyurular',
            // ------------------------------------------- Ayarlar ---------------------------------------------------------
            ayarlar: 'Ayarlar',
            talepTürleri: 'Talep Türleri',
            dosyaTürleri: 'Dosya Türleri',
            talepDurumlari: 'Talep Durumları',
            dosyaDurumlari: 'Dosya Durumları',
            mailMesajlari: 'Mail Mesajları',
            bilgiBankasiKategoriler: 'Bilgi Bankası Kategoriler',
            bilgiBankasiKategorileri: 'Bilgi Bankası Kategorileri',
            ghibHakkinda: 'GHİB Hakkında',
            duyurular: 'Duyurular',
            mevcutKayitlariDuzenle: "Mevcut Kayıtları Düzenle",
            duyuruListesi : 'Duyuru Listesi',
            details: 'Detaylar',
            sirketlerhissedevralinmasi: 'M&A-Hisse Devralınması İşlemleri',
            sirketlerortaklik: 'Ortaklık - Joint Venture İşlemleri',
            sirketlerdiligence: 'Due Diligence Koordinasyonu',
            sirketleristirakler: 'Yurtdışı Dava ve İhtilafların Koordinasyonu',
            sirketlertoplanti: 'Toplantı',
            sirketleregitim: 'Eğitim',
            sirketlersozlesmehazirlanmasi: 'Sözleşme Hazırlanması, İncelemesi',
            sirketlersozlesmeuyumsuzluk: 'Sözleşmelerle İlgili Soru ve Uyuşmazlıklar',
            sirketlerihtarname: 'İhtarname Hazırlanması Cevap verilmesi',
            sihtarname: 'İhtarname Hazırlanması Cevap verilmesi',
            sirketlermutalaa: 'Mütalaa (Danışma)',
            sirketlerraporlamalar: 'Raporlamalar',
            sirketlervekaletname: 'Vekaletname Hazırlanması/ İncelenmesi',
            ishukukusurec: 'İş Hukuku Fesih Süreçleri',
            ticarethukukufesih: 'İş Hukuku Fesih Süreçleri',
            ughsozlesmehazirlanmasi: 'Telif Sözleşmesi Hazırlanması, İncelenmesi',
            ughsozlesmeuyumsuzluk: 'Sözleşmelerle İlgili Soru ve Uyuşmazlıklar',
            // PLADIS
            pladissozlesmehazirlanmasi: 'Sözleşme Hazırlanması, İncelemesi',
            pladissozlesmeuyusmazliklar: 'Sözleşmelerle İlgili Soru ve Uyuşmazlıklar',
            pladisyenidava: 'Yeni Dava Açılması',
            pladisaleyheacilan: 'Aleyhe açılan davanın takibi',
            pladisicra: 'İcra Takibi',
            pladissavcilik: 'Savcılık Şikayetleri',
            pladismutalaa: 'Mütalaa (Danışma)',
            pladishaciz: 'Haciz İhbarnameleri ve Maaş Haciz Yazılarına Cevap Verilmesi',
            pladismahkemelerdengelenyazilar: 'Mahkemelerden Gelen Yazıların Cevaplandırılması',
            pladisishukukufesih: 'İş Hukuku Fesih Süreçleri',
            pladisraporlamalar: 'Raporlamalar',
            pladisegitim: 'Eğitim',
            pladisttoplanti: 'Toplantı',
            pladisihtarname: 'İhtarname Hazırlanması, Cevap Verilmesi',
            pladisvekaletname: 'Vekaletname Hazırlanması/İncelenmesi',
            // Marka
            mpmarkaPatentEndustriyelTasarim: 'Marka, Patent, Endüstriyel Tasarım İşlemleri',
            mpsinaiHaklarSozlesmeHazirlama: 'Sınai Haklara İlişkin Sözleşme/Beyan Hazırlanması',
            mpyurtdisiYeniDavaAcilmasi: 'Yurtdışında Yeni Dava Açılması',
            mpyurtdisiAleyheDavaTakibi: 'Yurtdışında Aleyhe Açılan Davanın Takibi',
            mpyurtdisiIhtarnameHazirlanmasi: 'Yurtdışında İhtarname Hazırlanması, Cevap Verilmesi',
            mpegitim: 'Eğitim',
            mptoplanti: 'Toplantı',
            mpraporlamalar: 'Raporlamalar',
            mpmutalaaDanisma: 'Mütalaa (Danışma)',
            thkamulastirma: 'Kamulaştırma ve İmar Mevzuatına İlişkin Davalar',
            thyurtdisidava: 'Yurtdışı dava ve ihtilafların koordinasyonu'
          },
          demandCreate: {
            turkiyeSirketleri: 'Türkiye Şirketleri',
            yurtDisiSirketleri: 'Yurtdışı Şirketleri',
            dosyaNo: 'Dosya No',
            grup: 'Grup',
            mensei: 'Menşei',
            grupSirketi: 'Grup Şirketi',
            sorumluAdi: 'Sorumlu Adı',
            sorumluEPosta: 'Sorumlu E-posta',
            sorumluTel: 'Sorumlu Tel',
            sorumluRol: 'Sorumlu Rolü',
            dosyaTürü: 'Dosya Türü',
            dosya: 'Dosya',
            konu: 'Konu',
            aciklama: 'Açıklama',
            dil: 'Dil',
            paraBirimi: 'Para Birimi',
            tahminiBedel: 'Tahmini Bedel',
            bedel: 'Bedel',
            davali: 'Davalı',
            müdahil: 'Müdahil',
            daireNo: 'Mahkeme No',
            taraf1: 'Taraf 1',
            yeniTalepButton: 'Yeni Talep',
            ekle: 'Ekle',
            yurtici: 'Yurtiçi',
            yurtdisi: 'Yurtdışı',
            davaTuru: 'Dava Türü',
            vekil: "Vekil",
            basvuruYapilacakSirket: "Başvuru Yapılacak Şirket",
            davaci: "Davacı",
            ihtarEdilen: "İhtar Edilen",
            vekilinCalistigiSirket: "Vekilin Çalıştığı Şirket",
            musteki: "Müşteki",
            ihtarEden: "İhtar Eden",
            supheli: "Şüpheli",
            durusmaTarihi: "Duruşma Tarihi",
            davaTutari: "Dava Tutarı",
            takipTutari: "Takip Tutarı",
            sozlesmeBedeli: "Sözleşme Bedeli",
            resmiDaire: "Resmi Daire",
            ilgiliSirket: "İlgili Şirket",
            alacakli: "Alacaklı",
            borclu: "Borçlu",
            turkiyeSirketleriUyari: "Bu talep türünde sadece Yıldız Holding Türkiye İştirak Şirketlerinden talep açılabilmektedir. İştirak Şirketi olmayan şirketlerden talep açmak için Ticaret Hukuku departmanından talep açınız.",
            ticaretHukukuUyari: "Bu talep türünde sadece Yıldız Holding Türkiye İştirak Şirketi olmayan şirketlerden talep açılabilmektedir. İştirak Şirketleri için Türkiye İştirakleri Hukuku departmanından talep açınız.",
            turkiyeSirketleriVeTicaretHukUyari: "\“Yıldız Holding Türkiye İştirakleri\” şirketleri için \“Türkiye İştirakleri Hukuku\“ sekmesinden, Yıldız Holding, pladis, Godiva, Yıldız Ventures ve diğer grup şirketlerimiz için ise Ticaret Hukuku sekmesinden talep açılabilecektir.",
            successCreate: "{{id}} numaralı işleminiz başarıyla kaydedilmiştir.",
            other: 'Diğer',
            markImportant: 'Önemli olarak işaretle',
            muddeabih:"Müddeabih",
            muddeabihRisk:"Müddeabih/Risk Tutarı",
            ilgiliSirket: "İlgili Şirket (Adına talep girilen şirket bilgisi)",
            sirketUyari: "Şirketler hukuku sekmesinden açılan taleplerde , yurtdışı-yurtiçi şirketi seçeneklerinin her ikisi de işaretlendikten sonra işlem yapılmalıdır."
          },
          grupCompanies: {
            grup: 'Grup',
            menşei: 'Menşei',
            kurumTipi: 'Kurum Tipi',
            sirket: 'Şirket',
            ghibSorumlusu: 'GHİB Sorumlusu',
            notlar: 'Notlar',
            ilgiliAvukat: 'İlgili Şirket Avukatı'
          },
          groups: {
            grup: 'Grup',
            grupEn: 'Grup (İngilizce)',
            sirketler: 'Şirketler',
          },
          roles: {
            adi: 'Adı',
            aciklama: 'Açıklama',
          },
          sozlesmeler: {
            dosyaNo: 'Dosya No',
            islemNo: 'İşlem No',
            dosyaTuru: 'Dosya Türü',
            durum: 'Durum',
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            konu: 'Konu',
            taraf: 'Taraf',
            dil: 'Dil',
            avukat: 'Avukat',
            tahminiBilgi: 'Tahmini Bedel',
            paraBirimi: 'Para Birimi',
            baslangicBedel: 'Başlangıç Bedel',
            bitisBedel: 'Bitiş Bedel',
            baslangicTarihi: 'Eklenme Tarihi (Başlangıç)',
            bitisTarihi: 'Eklenme Tarihi (Bitiş)',
            filtreleme: 'Filtreleme',
            filtrele: 'Filtrele',
          },
          vekaletnameler: {
            islemNo: 'İşlem No',
            vekaletnameNo: 'Vekaletname No',
            durum: 'Durum',
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            konu: 'Konu',
            avukat: 'Avukat',
            baslangicTarihi: 'Başlama Tarihi',
            bitisTarihi: 'Bitiş Tarihi',
            filtreleme: 'Filtreleme',
          },
          davaIcraSavcilik: {
            golgeDNo: 'Gölge D. No',
            islemNo: 'İşlem No',
            kullaniciadi: 'Kullanıcı Adı',
            mahkemeNo: 'Mahkeme No',
            icraNo: 'İcra No',
            dosyaTuru: 'Dosya Türü',
            dosyaGrubu: 'Dosya Grubu', // 'Dosya Grubu'
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            konu: 'Konu',
            aciklama: 'Açıklama',
            davaci: 'Davacı',
            davaciDiger: 'Davacı Diğer',
            davaciList : 'Davacı Listesi',
            davali: 'Davalı',
            davaliDiger: 'Davalı Diğer',
            davaliList : 'Davalı Listesi',
            avukat: 'Avukat',
            eklemeBaslangicTarihi: 'Eklenme (Başlangıç Tarihi)',
            eklemeBitisTarihi: 'Eklenme (Bitiş Tarihi)',
            kapanisBaslangicTarihi: 'Kapanış (Başlangıç Tarihi)',
            kapanisBitisTarihi: 'Kapanış (Bitiş Tarihi)',
            durusmaTakipBasTarihi: 'Duruşma/Takip (Başlangıç Tarihi)',
            durusmaTakipBitTarihi: 'Duruşma/Takip (Bitiş Tarihi)',
            DavaciSirket: 'Davacı Şirket',
            Davacikisi: 'Davacı Kışı',
            DavaliSirket: 'Davalı Şirket',
            davaciSirket: 'Davacı Şirket'
          },
          ihtarnameler: {
            islemNo: 'İşlem No',
            ihtarnameNo: 'İhtarname No',
            taraf: 'Taraf',
            durum: 'Durum',
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            dosyaTuru: 'Dosya Türü',
            konu: 'Konu',
            avukat: 'Avukat',
            baslangicTarihi: 'Başlama Tarihi',
            bitisTarihi: 'Bitiş Tarihi',
            filtreleme: 'Filtreleme',
          },
          isAkdiFesihleri: {
            islemNo: 'İşlem No',
            isAkdiFesihNo: 'İş Akdi Fesih No',
            taraf: 'Taraf',
            durum: 'Durum',
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            dosyaTuru: 'Dosya Türü',
            konu: 'Konu',
            avukat: 'Avukat',
            baslangicTarihi: 'Başlama Tarihi',
            bitisTarihi: 'Bitiş Tarihi',
            filtreleme: 'Filtreleme',
          },
          demandTypes: {
            departman: 'Departman',
            talepTürü: 'Talep Türü',
            talepTürüTr: 'Talep Türü(Türkçe)',
            talepTürüEn: 'Talep Türü(İngilizce)',
            numaraOneki: 'Sıra No',
          },
          documentTypes: {
            departman: 'Departman',
            üstTür: 'Üst Tür',
            talepTürleri: 'Talep Türleri',
            türKodu: 'Tür Kodu',
            dosyaTürü: 'Dosya Türü',
            dosyaTürüTr: 'Dosya Türü(Türkçe)',
            dosyaTürüEn: 'Dosya Türü(İngilizce)',
            ücret: 'Ücret',
            talepTuru: 'Talep Türü'
          },
          demandStates: {
            talepDurumu: 'Talep Durumu',
            talepDurumuEn: 'Talep Durumu(İngilizce)',
            talepDurumuTr: 'Talep Durumu(Türkçe)',
          },
          newAnnouncements: {
            baslik : 'Duyuru Başlığı',
            icerik : 'İçerik',
            bitisTarihi : 'Bitiş Tarihi',
            aktif: 'Aktiflik Durumu',
            duyuru: 'Duyuru Ekle'
          },
          documentStates: {
            departman: 'Departman',
            talepTürleri: 'Talep Türleri',
            durumKodu: 'Durum Kodu',
            dosyaDurumu: 'Dosya Durumu',
            dosyaDurumuTr: 'Dosya Durumu(Türkçe)',
            dosyaDurumuEn: 'Dosya Durumu(İngilizce)',
          },
          demandDocType: {
            evrakTipi: 'Evrak Tipi Adı',
            evrakTipiEn: 'Evrak Tipi Adı(İngilizce)',
            evrakTipiTr: 'Evrak Tipi Adı(Türkçe)',
          },
          mailMessages: {
            mailKodu: 'Mail Kodu',
            aciklama: 'Açıklama',
            konu: 'Konu',
            mesaj: 'Mesaj',
          },
          infoBanksCategories: {
            ustKategori: 'Üst Kategori',
            kategoriAdi: 'Kategori Adı',
          },
          announcements: {
            duyuruBasligi: 'Duyuru Başlığı',
            duyuruMetni: 'Duyuru Metni',
          },
          fileUpload: {
            dosyaUpload: 'Dosya yüklemek için sürükleyip bırakabilir ya da tıklayabilirsiniz',
            uploadSuccess: 'Dosya başarıyla yüklendi!',
          },
          tamamlaButton: {
            tamamla: 'Tamamla',
            gonder: 'Gönder',
          },
          demandList: {
            islemNo: 'GLAS İşlem No',
            grup: 'Grup',
            grupSirketi: 'Grup Şirketi',
            ilgiliSirket: 'İlgili Şirket',
            talepTuru: 'Talep Türü',
            talepTuruTr: 'Talep Türü(Türkçe)',
            talepTuruEn: 'Talep Türü(İngilizce)',
            talepDurumu: 'Talep Durumu',
            talepDurumuTr: 'Talep Durumu(Türkçe)',
            talepDurumuEn: 'Talep Durumu(İngilizce)',
            konu: 'Konu',
            isGücüBirim: 'İş Gücü Birim',
            departmanAdi: 'Departman Adı',
            kullaniciAdi: 'Kullanıcı Adı',
            adiSoyadi: 'Adı Soyadı',
            userName: 'Kullanıcı Adı',
            avukatKodu: 'Avukat Kodu',
            ePosta: 'E-posta',
            telefon: 'Telefon',
            durum: 'Durum',
            durumAktif: 'Aktif',
            durumPasif: 'Pasif',
            aktifDurum: 'Aktif Talep Türü mü?',
            kurumTip: 'Kurum Tipi',
            kurumAdi: 'Kurum Adı',
            grupAdi: 'Grup Adı',
            grupAdiEn: 'Grup Adı (İngilizce)',
            adi: 'Adı',
            aciklama: 'Açıklama',
            grupSirket: 'Grup Şirketi',
            turKodu: 'Tür Kodu',
            dosyaTuru: 'Dosya Türü',
            dosyaTuruTr: 'Dosya Türü(Türkçe)',
            dosyaTuruEn: 'Dosya Türü(İngilizce)',
            durumKodu: 'Durum Kodu',
            dosyaDurumu: 'Dosya Durumu',
            dosyaDurumuTr: 'Dosya Durumu(Türkçe)',
            dosyaDurumuEn: 'Dosya Durumu(İngilizce)',
            mailKodu: 'Mail Kodu',
            ustKategoriAdi: 'Üst Kategori Adı',
            kategoriAdi: 'Kategori Adı',
            duyuruBas: 'Duyuru Başlığı',
            gonderenKisi: 'Gönderen Kişi',
            tarih: 'Tarih',
            sozlesmeNo: 'Sözleşme No',
            dil: 'Dil',
            bedel: 'Bedel',
            karsiTaraf: 'Karşı Taraf',
            sözlesmeTuru: 'Sözleşme Türü',
            baslangicTarihi: 'Başlama Tarihi',
            bitisTarihi: 'Bitiş Tarihi',
            dövizCinsi: 'Döviz Cinsi',
            ekleyen: 'Ekleyen',
            eklemeTarihi: 'Eklenme Tarihi',
            avukat: 'Avukat',
            golgeDNo: 'Gölge D. No',
            departman: 'Departman',
            gorevliAvukat: 'Görevli Dış Avukat',
            talepTarihi: 'Başlama Tarihi',
            tamamlamaTarhihi: 'Bitiş Tarihi',
            tamamlamaTarihi: 'Tamamlanma Tarihi',
            talepBilgisi: 'Talep Bilgisi',
            vekaletNo: 'Vekalet No',
            isAkdiFesihNo: 'İş Akdi Fesih No',
            isAkdiFesihTuru: 'İş Akdi Fesih Türü',
            ihtarnameNo: 'İhtarname No',
            ihtarnameTuru: 'İhtarname Türü',
            davaci: 'Davacı',
            davali: 'Davalı',
            davaTuru: 'Dava Türü',
            sonDurum: 'Son Durum',
            sirketIciYetkili: 'Şirket İçi Yetkililer',
            yetkiliKisi: 'Yetkili Kişi',
            kullaniciRolu: 'Kullanıcı Rolü',
            disKod: 'Dış Kod',
            taraf1: 'Davacı',
            siraNo: 'Sıra No',
            sirketDurumu: "Şirket Durumu",
            yurtici: "Türkiye/Yurtdışı Şirketleri",
            istirakSirketleri: "İştirak Şirketleri",
            KullaniciAdi: "Kullanıcı Adı",
            bekleyenSayisi: "Bekleyen Sayısı",
            atananSayisi: "Yönlendirilmiş Talepler",
            devamEdenSayisi: "Devam Eden Sayısı",
            tamamlananlarSayisi: "Tamamlananlar Sayısı",
            importantInfo: "Önemli olarak işaretlendi mi?",
            enAz:"En az",
            enCok: "En çok",
            muddeabih:"Müddeabih",
            muddeabihRisk:"Müddeabih/Risk Tutarı",
            davaTuru1: "Dava Türü 1",            
            davaTuru2: "Dava Türü 2",
            masrafCheck: "Masraf Sekmesi"
          },
          pageTitleofDemandCreate: {
            sirketlerHukukuToplanti: 'Ticaret Hukuku Toplantı',
            sirketlerHukukuEgitim: 'Ticaret Hukuku Eğitim',
            davaIcraToplanti: 'Türkiye İştirakleri Hukuk Toplantı ',
            davaIcraEgitim: 'Türkiye İştirakleri Hukuk Eğitim',
            sözlesmelerHukukuToplanti: 'Sözleşmeler Hukuku Toplantı',
            sözlesmelerHukukuEgitim: 'Sözleşme Hukuku Eğitim',
            fmhToplanti: 'Fikri Mülkiyet Hukuku Toplantı',
            fmhEgitim: 'Fikri Mülkiyet Hukuku Eğitim',
            genelHukukToplanti: 'Genel Hukuk Toplantı',
            genelHukukEgitim: 'Genel Hukuk Eğitim',
            regulasyonToplanti: 'Regülasyon Toplantı',
            regulasyonEgitim: 'Regülasyon Eğitim',
            baskanlikToplanti: 'Başkanlık Toplantı',
            talepDurum: 'Talep Durumu',
            dosyaDurum: 'Dosya Durumu',
            mailMesajı: 'Mail Mesajı',
            bilgiBankasiKategori: 'Bilgi Bankası Kategori',
            bilgiBankasiFiles: 'Bilgi Bankası Dosyalar',
            duyuru: 'Duyuru',
            evrakTipi: 'Evrak Tipi',
            isyogunlugu:'iş yoğunluğu'
          },
          anaSayfa: {
            glasaHosGeldiniz: "Glas'a Hoş Geldiniz!",
            avukatlikYoneticisi: 'Avukatlık Yöneticisi Kontrol Paneli',
            onayBekleyenTalepler: 'ONAY BEKLEYEN TALEPLER',
            bekleyenTalepler: 'BEKLEYEN TALEPLER',
            yonlendirilmisTalepler: 'YÖNLENDİRİLMİŞ TALEPLER',
            surecDevamEdenTalepler: 'DEVAM EDEN TALEPLER',
            sureciDevamEdenTalepler: 'SÜRECİ DEVAM EDİYOR',
            tumTalepler: 'TÜM TALEPLER',
            tamamlananlar: 'TAMAMLANANLAR',
            reddedilenler: 'REDDEDİLENLER',
            yeniTalepler: 'YENİ TALEPLER',
            dosyalar: 'DOSYALAR',
            atananlar: 'ATANANLAR',
            duyurular: 'DUYURULAR',
            evrakTipi: "Evrak Tipi"
          },
          table: {
            veriYok: 'Veri yok!',
            kayitaraligi: 'Kayıttan-Arası-Kayıtlar',

            glasIslemNo:'Glas İşlem No',
            grupSirketi: 'Grup Şirketi',
            talep:'Talep',
            konu:'Konu',
            isGucuBirim:'İş Gücü Birimi',
            baslamaTarihi: 'Başlama Tarihi',
            bekleyenler: 'Bekleyenler',
            yonlendirilmis:'Yönlendirilmiş',
            devamEden: 'Devam Eden',
            tammam:'Tammamlanmış',
            sorumluAdi: 'Sorumlu Adı'
          },
          actionButtons: {
            islemler: 'İşlemler:',
          },
          demandUpdate: {
            islemNo: 'GLAS İşlem No',
            talepEdenSirket: 'Talep Eden Şirket',
            talepEdenKisi: 'Talep Eden Kişi',
            talepTarihi: 'Talep Tarihi',
            dosya: 'Dosya',
            sorumluAdi: 'Sorumlu Adı',
            sorumluePosta: 'Sorumlu E-posta',
            sorumluTelefon: 'Sorumlu Telefon',
            dosyaTuru: 'Dosya Türü',
            konu: 'Konu',
            explanation: 'Açıklama',
            avukatYorumu: 'Avukat Yorumu',
            yonlendiriciYorumu: 'Yönlendirici Yorumu',
            delegeEdilen: 'Delege Edilen',
            iadeNedeni: 'İade Nedeni',
            iadeEdenKullanici: 'İade Eden Kullanıcı',
            iadeTarihi: 'İade Tarihi',
            redNedeni: 'Red Nedeni',
            redEdenKullanici: 'Red Eden Kullanıcı',
            redTarihi: 'Red Tarihi',
            dil: 'Dil',
            isGucuBirim: 'İş Gücü Birim',
            isGucuBirimDiger: 'İş Gücü Birim Diğer',
            davaTuru: 'Dava Türü',
            tarih: 'Tarih',
            dosyaDurum: 'Dosya Durumu',
            gorevlendirilenDisAvukat: 'Görevlendirilen Dış Avukat',
            gorevlendirilenDisAvukatDiger: 'Görevlendirilen Dış Avukat (Diğer)',
            davali: 'Davalı',
            müdahil: 'Müdahil',
            daireNo: 'Mahkeme No',
            icraNo: 'İcra No',
            taraf: 'Taraf 1',
            disAvukatGorebilir: 'Dış Avukat Görebilir',
            talepFiltrele: 'Talep Filtreleme',
            bilgideTut: "Bilgide Tut",
            savcilikNo: "Savcılık No",
            importantInfo: "Önemli olarak işaretlendi mi?",
            davaTuru1: "Dava Türü 1",            
            davaTuru2: "Dava Türü 2",
            disAvukatAdSoyAd: "Dış Avukat Ad-Soyad",
            digerDisAvukatAdSoyAd: "Diğer Dış Avukat Ad-Soyad",
            makbuzAciklamasi: "Makbuz Açıklaması"
          },
          documentUpdate: {
            islemNo: 'GLAS İşlem No',
            dosyaNo: 'Dosya No',
            dosya: 'Dosya',
            sorumluAdi: 'Sorumlu Adı',
            sorumluEPosta: 'Sorumlu E-posta',
            sorumluTelefon: 'Sorumlu Telefon',
            dosyaTuru: 'Dosya Türü',
            konu: 'Konu',
            aciklama: 'Açıklama',
            dosyaDurum: 'Dosya Durumu',
            tahminiBedel: 'Tahmini Bedel',
            bedel: 'Bedel',
            paraBirimi: 'Para Birimi',
            dil: 'Dil',
            baslangicTarihi: 'Başlangıç Tarihi',
            bitisTarihi: 'Bitiş Tarihi',
            avukatYorumu: 'Avukat Yorumu',
            yonlendiriciYorumu: 'Yönlendirici Yorumu',
            yorumlar: 'Yorumlar',
            sicilKaydiVar: 'Sicil Kaydı Var',
            sirkulerVar: 'Sirküler Var',
            cezaVar: 'Ceza Var',
          },
          actionButtonGenerator: {
            guncelle: 'Güncelle',
            aktifEt: 'Aktif Et',
            pasifEt: 'Pasif Et',
            sayfayaGit: 'Sayfaya Git',
            sil: 'Sil',
            dosyaYukle: 'Dosya Yükle',
            kullaniciDosyaYukle: 'Kullanıcı Dosyaları',
            dosyaIndir: 'Dosya İndir',
            dosyalariIndir: 'İndir',
            goruntule: 'Görüntüle',
            yetkiEkle: 'Yetki Ekle',
            atamaYap: "Atama Yap",
            red: "Reddet",
            baslat: "Başlat",
            iadeEt: "İade Et",
            dosyayaDonustur: "Kaydet",
            numaraVer: "Kaydet ve Numara Ver",
            taslak: "Taslak Kaydet",
            tamamla: "Tamamla",
            numaraVermeden: "Numara Vermeden Bitir",
            bitir: "Bitir",
            kaydet: "Kaydet",
            kaydettt: "Kaydetttt",
            ogeSecildi: "Öğe Seçildi",
            excel: "Excel Olarak İndir",
            formuTemizle: "Formu Temizle",
            tumKayitlariGuncelle: "Tüm Kayıtları Güncelle",
            arsivVeYonetim: 'Arşiv ve Yönetim',
            infazNumaraVer: 'İnfaz Numarası Ver',
            deneme: 'Deneme',
          },
          header: {
            profile: "Profile git",
            logout: "Çıkış yap",
            bulunamadi: "Bulunamadı",
          },
          report: {
            gorevlendirilen: "Görevli Avukat",
            talepatbas: "Talep Açılış Tarihi(Başlangıç)",
            talepatbts: "Talep Açılış Tarihi(Bitiş)",
            talepktbas: "Talep Kapanış Tarihi(Başlangıç)",
            talepktbts: "Talep Kapanış Tarihi(Bitiş)",
            talepDurumuId: "Talep Durumu ID",
            kapanmaTarihi: "Kapanma Tarihi",
            toplamSure: "Toplam Süre",
            isGucuBirim: "İş Gücü Birimi",
            sonDurum: "Son Durum",
            sonDurumEkleyen: "Son Durum Ekleyen",
            durusmaTarihiMin: "Duruşma Tarihi (Başlangıç)",
            durusmaTarihiMax: "Duruşma Tarihi (Bitiş)",
            listeAlanlari: "Liste Alanları",
            golgeNumarasi: "Glas Gölge Numarası var mı?",
          },
          tabs: {
            bilgiler: "Bilgiler",
            sonDurum: "Son Durum",
            dokumanlar: "Dokümanlar",
            harcananSureler: "Harcanan Süreler",
            talepAkisi: "Talep Akışı",

            ekleyen: "Ekleyen",
            durum: "Durum",
            tarih: "Tarih",
            eklendi: "Eklendi",
            guncellendi: "Güncellendi",
            successDelete: "Silme işlemi başarılı",

            evrakTipi: "Evrak Tipi",
            evrakTipiAciklamasi: "Evrak Tipi Açıklaması",
            digerEvrakTipi: "Diğer Evrak Tipi",
            dosyaAdi: "Dosya Adı",

            sureDakika: "Süre(Dakika)",
            aciklama: "Açıklama",
            ilgiliKisi: "İlgili Kişi",
            sure: "Süre",

            islemTipi: "İşlem Tipi",
            tarihSaat: "Tarih - Saat",

            ekle: "Ekle",
            Bekleyenler: 'Bekleyenler',
            YonlendirilmisTalepler: 'Yönlendirilmiş Talepler',
            DevamEdenTalepler:'Devam Eden Talepler',
            TammamlanimisTalepler:'Tamamlanmış Talepler',
            kullanicilar:"Kullancılar",
            guncelle: 'Güncelle',
            kullanicilar: 'Kullanıcılar',
            KullaniciDosyalari:'Kullanıcı Dosyaları',
            Roller: 'Roller',
            departmanlar:'Departments',
            kullaniciBilgileri: 'Kullanıcı Bilgileri',
           
            masraflar: 'Masraflar'
          },
          userRole: {
            kullanici: "Kullanıcı",
            kullaniciDosya: "Kullanıcı Dosyaları",
            sirketGrubu: "Şirket Grubu",
            rolAdi: "Rol Adı",
            rol: "Rol",
            back: "Geri Dön",
            kullaniciRol: "Kullanıcı-Rol",
            roller: "Roller",
            menuler: "Menüler",
            sirketler: "Şirketler",
            masraflarSekmesindeMi: "Masraflar sekmesine erişimi var mı?"
          },
          userDepartment: {
            talepTurleriId: "Talep Türleri ID",
            talepTurleriAdı: "Talep Türü",
            talepTurleri: "Talep Türleri",
            kullaniciDepartman: "Kullanıcı-Departman",
            departmanlar: "Departmanlar"
          },
          userArchiveCheckBox: {
            ARSIV_SOZLESME_VEKALET: "Sözleşme / Vekaletname",
            ARSIV_DAVA_ICRA: "Dava / İcra"
          },
          modal: {
            yesButton: "Evet",
            noButton: "Hayır",
            areYouSure: "Devam etmek istediğinizden emin misiniz?",
            warningTitle: "Uyarı!",
          },
        }
      },
    }
  });

export default i18n;